import { useRef, useState } from "react";
import { Upload, X, Loader2, ImageIcon } from "lucide-react";
import { toast } from "sonner";
import { uploadImage, mediaUrl } from "../../lib/api";

export const ImageUpload = ({ value, onChange, testid }) => {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const { url } = await uploadImage(file);
      onChange(url);
      toast.success("Imagen subida");
    } catch (err) {
      toast.error("Error al subir la imagen");
    } finally {
      setLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="flex items-center gap-4">
      <div className="flex h-20 w-20 items-center justify-center overflow-hidden rounded-xl border border-white/10 bg-glg-black/60">
        {value ? (
          <img src={mediaUrl(value)} alt="preview" className="h-full w-full object-cover" />
        ) : (
          <ImageIcon className="h-6 w-6 text-white/25" />
        )}
      </div>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          data-testid={testid}
          className="inline-flex items-center gap-2 rounded-lg border border-white/15 bg-white/5 px-4 py-2 text-sm text-white hover:bg-white/10"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
          Subir
        </button>
        {value && (
          <button type="button" onClick={() => onChange("")} className="inline-flex items-center gap-1 rounded-lg border border-white/15 px-3 py-2 text-sm text-white/60 hover:text-white">
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handle} />
    </div>
  );
};

export const ImageListUpload = ({ value = [], onChange }) => {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setLoading(true);
    try {
      const urls = [];
      for (const f of files) {
        const { url } = await uploadImage(f);
        urls.push(url);
      }
      onChange([...(value || []), ...urls]);
      toast.success("Imágenes subidas");
    } catch (_) {
      toast.error("Error al subir imágenes");
    } finally {
      setLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      <div className="flex flex-wrap gap-2">
        {(value || []).map((v, i) => (
          <div key={i} className="relative h-20 w-20 overflow-hidden rounded-xl border border-white/10">
            <img src={mediaUrl(v)} alt="" className="h-full w-full object-cover" />
            <button type="button" onClick={() => onChange(value.filter((_, idx) => idx !== i))} className="absolute right-1 top-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-black/70 text-white">
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
        <button type="button" onClick={() => inputRef.current?.click()} className="flex h-20 w-20 items-center justify-center rounded-xl border border-dashed border-white/20 text-white/40 hover:text-white">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Upload className="h-5 w-5" />}
        </button>
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple className="hidden" onChange={handle} />
    </div>
  );
};
